export default __webpack_public_path__ + "static/media/BrainBreak cards51.5b115fe9.png";